/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_fda9041b .ms-Suggestions-itemButton{padding:0;border:none}.callout_fda9041b .ms-Suggestions{min-width:300px}"}]);
export const callout = "callout_fda9041b";